import { useQuery } from "react-query";

import { Nullable, UUID } from "foundation-ts/types";
import { DriveItemStructure } from "doxecure-commons/doxecureTypes";

import { useAuthContext } from "@hooks/useAuthContext";
import { getDriveFolderContent } from "@services/drive.service";

export const useGetFolderContent = (userChannelID: Nullable<UUID>, folder: string) => {
    const { connectedProfileId } = useAuthContext();

    return useQuery<Array<DriveItemStructure>>(["drives", userChannelID, folder], () =>
        getDriveFolderContent(connectedProfileId, userChannelID, folder)
    );
}